import Header from "../../components/commalax-landing/header";
import Footer from "../../components/commalax-landing/footer";
import { Brands, brandLogos } from "./mock";
import Products from "../../components/commalax-landing/products";
import Container from "../../components/commalax-landing/container";
import Banner from "../../components/commalax-landing/banner";
import ShopByBrands from "../../components/commalax-landing/shops";
import ShopNow from "../../components/commalax-landing/shop-now";

const Home = () => {
  return (
    <div className="poppin-font bg-[#E3E3E3] min-h-screen space-y-10 md:space-y-20">
      <div className="space-y-5 md:space-y-10">
        <Header />
        <Banner />
      </div>

      <Container className={"space-y-16 md:space-y-20"}>
        {Brands.map((brand, idx) => {
          return <Products key={idx} {...brand} />;
        })}
      </Container>
      <ShopByBrands logos={brandLogos} />
      <ShopNow />
      <Footer />
    </div>
  );
};

export default Home;
